<template>
  <div class="pipeline_layout--aside">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PipelineLayoutTabAside",
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.pipeline_layout--aside {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 320px;
  overflow-y: auto;
  padding-right: $defaultGap;

  @media screen and (min-width: 1300px) {
    flex-basis: 360px;
  }

  @media screen and (min-width: 1500px) {
    flex-basis: 400px;
  }
}
</style>
